export default "__VITE_PUBLIC_ASSET__f020e5a5__"